/** The onboarding task choice's "Skip for now": keep the proposed tasks when
 * offered, otherwise finish onboarding. Other questions have neither option. */
export function contextualDeclineOption<T extends { id: string }>(
  options: readonly T[] | undefined,
): T | undefined {
  return (
    options?.find((option) => option.id === "save_tasks") ??
    options?.find((option) => option.id === "finish_onboarding")
  );
}
